/* =============================================================
   DREYA — Theme JavaScript
   ============================================================= */

document.addEventListener('DOMContentLoaded', () => {

  /* ── Header: transparent → solid on scroll ── */
  const header = document.getElementById('site-header');
  if (header && header.dataset.transparent === 'true') {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Nav Drawer ── */
  const navToggle   = document.getElementById('nav-toggle');
  const navDrawer   = document.getElementById('nav-drawer');
  const isMobile = () => window.innerWidth <= 900;
  const openNav = () => {
    navToggle.classList.add('active');
    navDrawer.classList.add('open');
    navDrawer.setAttribute('aria-hidden', 'false');
    navToggle.setAttribute('aria-expanded', 'true');
    header.classList.add('menu-open');
  };
  const closeNav = () => {
    navToggle.classList.remove('active');
    navDrawer.classList.remove('open');
    navDrawer.setAttribute('aria-hidden', 'true');
    navToggle.setAttribute('aria-expanded', 'false');
    header.classList.remove('menu-open');
    document.body.style.overflow = '';
  };
  if (navToggle && navDrawer) {
    navToggle.addEventListener('click', () =>
      navDrawer.classList.contains('open') ? closeNav() : openNav()
    );
    // Close mobile dropdown when tapping outside
    document.addEventListener('click', e => {
      if (isMobile() && navDrawer.classList.contains('open') &&
          !navDrawer.contains(e.target) && !navToggle.contains(e.target)) {
        closeNav();
      }
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && navDrawer.classList.contains('open')) closeNav();
    });
    window.addEventListener('scroll', () => {
      if (navDrawer.classList.contains('open')) closeNav();
      if (cartDrawer && cartDrawer.classList.contains('open')) closeCart();
    }, { passive: true });
  }

  /* ── Search Drawer ── */
  const searchToggle = document.getElementById('search-toggle');
  const searchDrawer = document.getElementById('search-drawer');
  const searchClose  = document.getElementById('search-close');
  const searchInput  = document.getElementById('search-input');

  const openSearch = () => {
    searchDrawer.classList.add('open');
    searchDrawer.setAttribute('aria-hidden', 'false');
    setTimeout(() => searchInput?.focus(), 100);
  };
  const closeSearch = () => {
    searchDrawer.classList.remove('open');
    searchDrawer.setAttribute('aria-hidden', 'true');
  };

  searchToggle?.addEventListener('click', openSearch);
  searchClose?.addEventListener('click', closeSearch);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeSearch();
  });

  /* ── Cart Drawer ── */
  const cartToggle  = document.getElementById('cart-toggle');
  const cartDrawer  = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartClose   = document.getElementById('cart-close');

  const openCart = () => {
    cartDrawer?.classList.add('open');
    cartOverlay?.classList.add('open');
    cartDrawer?.setAttribute('aria-hidden', 'false');
    cartToggle?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  };
  const closeCart = () => {
    cartDrawer?.classList.remove('open');
    cartOverlay?.classList.remove('open');
    cartDrawer?.setAttribute('aria-hidden', 'true');
    cartToggle?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  cartToggle?.addEventListener('click', openCart);
  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeCart();
  });

  /* ── Toast notifications ── */
  let toastTimer;
  function showToast(msg) {
    const toast = document.getElementById('dreya-toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.style.display = 'block';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.style.display = 'none'; }, 3500);
  }

  /* ── Cart Quantity Controls ── */
  async function updateCartItem(key, qty) {
    if (qty < 0) return;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      const data = await res.json();
      if (!res.ok) {
        showToast(data.description || data.message || 'Unable to update quantity.');
        return;
      }
      updateCartUI(data);
    } catch (err) {
      showToast('Something went wrong. Please try again.');
      console.error('Cart update failed:', err);
    }
  }

  function updateCartUI(cart) {
    // Update count badges
    document.querySelectorAll('[data-count]').forEach(el => {
      el.setAttribute('data-count', cart.item_count);
      el.textContent = cart.item_count;
    });
    // Update drawer title
    const title = document.querySelector('.cart-drawer-title');
    if (title) title.textContent = `Shopping Bag (${cart.item_count})`;

    // If on full cart page, reload so all quantities and totals update correctly
    if (window.location.pathname === '/cart') {
      window.location.reload();
      return;
    }

    // Otherwise reload cart drawer contents
    fetch('/cart?section_id=cart-drawer-body')
      .then(r => r.text())
      .then(html => {
        const body = document.getElementById('cart-drawer-body');
        if (body) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          body.innerHTML = doc.body.innerHTML;
          bindQtyControls();
        }
      });
  }

  function bindQtyControls() {
    document.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const qty = parseInt(btn.dataset.qty, 10);
        updateCartItem(key, qty);
      });
    });
    document.querySelectorAll('[data-action="remove"]').forEach(btn => {
      btn.addEventListener('click', () => updateCartItem(btn.dataset.key, 0));
    });
  }
  bindQtyControls();
  window.dreyaBindCart = bindQtyControls;
  /* Garment measurements panel (21 Oct 2026): after adding from the panel, refresh the bag count and open the drawer */
  window.dreyaCartAdded = async () => { const cart = await fetch('/cart.js').then(r => r.json()); updateCartUI(cart); openCart(); };

  /* ── Add to Cart (product page) ── */
  function flagMissingSize() {
    const sizeErr = document.getElementById('dreya-size-error');
    if (sizeErr) sizeErr.style.display = 'block';
    const grid = document.querySelector('.size-btn')?.closest('.size-grid');
    if (grid) grid.classList.add('size-grid--error');
  }
  document.getElementById('dreya-custom-btn')?.addEventListener('click', () => {
    const sizeErr = document.getElementById('dreya-size-error');
    if (sizeErr) sizeErr.style.display = 'none';
    document.querySelector('.size-grid--error')?.classList.remove('size-grid--error');
  });

  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', async e => {
      e.preventDefault();
      const sizeButtons = document.querySelectorAll('.size-btn');
      if (sizeButtons.length > 0 && !document.querySelector('.size-btn.selected')) {
        flagMissingSize();
        return;
      }
      const btn = document.getElementById('add-to-cart-btn');
      const variantId = document.getElementById('variant-id')?.value;
      if (!variantId) return;

      btn.textContent = 'Adding...';
      btn.disabled = true;

      try {
        const formData = new FormData(productForm);
        const properties = {};
        for (const [key, val] of formData.entries()) {
          const m = key.match(/^properties\[(.+)\]$/);
          if (m && val) properties[m[1]] = val;
        }
        const cartPayload = { id: variantId, quantity: 1 };
        if (Object.keys(properties).length > 0) cartPayload.properties = properties;

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(cartPayload)
        });
        if (res.ok) {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          updateCartUI(cart);
          btn.textContent = 'Added!';
          setTimeout(() => {
            btn.textContent = 'Add to Bag';
            btn.disabled = false;
            openCart();
          }, 800);
        }
      } catch (err) {
        btn.textContent = 'Add to Bag';
        btn.disabled = false;
      }
    });
  }

  /* ── Buy Now ── */
  const buyNowBtn = document.getElementById('buy-now-btn');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', async () => {
      const sizeButtons = document.querySelectorAll('.size-btn');
      if (sizeButtons.length > 0 && !document.querySelector('.size-btn.selected')) {
        flagMissingSize();
        return;
      }
      const variantId = document.getElementById('variant-id')?.value;
      if (!variantId) return;
      buyNowBtn.textContent = 'Please wait...';
      buyNowBtn.disabled = true;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        // Refresh cart count + drawer immediately so bag isn't empty if user exits Razorpay
        const cart = await fetch('/cart.js').then(r => r.json());
        updateCartUI(cart);
        // Reset button before Razorpay modal opens — dismiss won't fire our catch block
        buyNowBtn.textContent = 'Buy Now';
        buyNowBtn.disabled = false;
        // Block idle/cart-recovery popups while Razorpay checkout is open
        window.DREYA_CHECKOUT_ACTIVE = true;
        // Reset flag the moment user touches the main page again (Razorpay closed)
        const onCheckoutExit = () => { window.DREYA_CHECKOUT_ACTIVE = false; };
        document.addEventListener('click', onCheckoutExit, { once: true });
        document.addEventListener('touchstart', onCheckoutExit, { once: true, passive: true });
        // Shopify's own checkout (branch default_checkout_main): go straight there
        window.location.href = '/checkout';
      } catch (err) {
        buyNowBtn.textContent = 'Buy Now';
        buyNowBtn.disabled = false;
      }
    });
  }

  /* ── Product: size selector ── */
  document.querySelectorAll('.size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      const sizeErr = document.getElementById('dreya-size-error');
      if (sizeErr) sizeErr.style.display = 'none';
      btn.closest('.size-grid')?.classList.remove('size-grid--error');

      const variantId = btn.dataset.variantId;
      const price     = btn.dataset.price;
      const available = btn.dataset.available === 'true';

      const variantInput = document.getElementById('variant-id');
      if (variantInput) variantInput.value = available ? variantId : '';

      /* Price block is rendered once by main-product (all sizes share one price); don't overwrite it */

      const sizeLabel = document.getElementById('selected-size');
      if (sizeLabel) sizeLabel.textContent = btn.dataset.value;

      const addBtn = document.getElementById('add-to-cart-btn');
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'Add to Bag' : 'Sold Out';
        addBtn.classList.toggle('btn-sold-out', !available);
      }
      const buyBtn = document.getElementById('buy-now-btn');
      if (buyBtn) buyBtn.style.display = available ? '' : 'none';
    });
  });

  /* ── Product Gallery: shared go-to-slide function ── */
  const thumbs = Array.from(document.querySelectorAll('.product-thumb'));
  const dots   = Array.from(document.querySelectorAll('.gallery-dot'));
  const mainWrap = document.getElementById('product-gallery-main');

  function goToSlide(index) {
    if (!thumbs.length) return;
    const total = thumbs.length;
    index = ((index % total) + total) % total;
    const thumb = thumbs[index];

    thumbs.forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    dots.forEach(d => d.classList.remove('active'));
    if (dots[index]) dots[index].classList.add('active');

    if (mainWrap) {
      const arrows = mainWrap.querySelector('.product-gallery__arrows');
      if (thumb.dataset.mediaType === 'video') {
        const vid = document.createElement('video');
        vid.id = 'main-product-video';
        vid.autoplay = true; vid.muted = true; vid.loop = false; vid.playsInline = true;
        vid.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
        const src = document.createElement('source');
        src.src = thumb.dataset.videoSources; src.type = 'video/mp4';
        vid.appendChild(src);
        mainWrap.innerHTML = ''; mainWrap.appendChild(vid);
        if (arrows) mainWrap.appendChild(arrows);
        attachSpeedCycle(vid);
      } else {
        const newImg = document.createElement('img');
        newImg.id = 'main-product-image';
        newImg.src = thumb.dataset.src;
        newImg.alt = thumb.dataset.alt || '';
        newImg.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
        mainWrap.innerHTML = ''; mainWrap.appendChild(newImg);
        if (arrows) mainWrap.appendChild(arrows);
      }
    }
  }

  function attachSpeedCycle(vid) {
    var SPEEDS = [1, 0.75, 0.5, 1];
    var MAX_PLAYS = 4;
    vid.playbackRate = SPEEDS[0];
    var plays = 0;
    function onEnd() {
      plays++;
      if (plays < MAX_PLAYS) {
        vid.playbackRate = SPEEDS[plays];
        vid.play();
      } else {
        vid.removeEventListener('ended', onEnd);
        var imgIdx = thumbs.findIndex(function(t) { return t.dataset.mediaType !== 'video'; });
        goToSlide(imgIdx !== -1 ? imgIdx : 0);
      }
    }
    vid.addEventListener('ended', onEnd);
  }

  function currentIndex() {
    const active = thumbs.findIndex(t => t.classList.contains('active'));
    return active >= 0 ? active : 0;
  }

  /* Thumbnail clicks */
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => goToSlide(parseInt(thumb.dataset.index || 0)));
  });

  /* Arrow clicks — desktop only (hidden on mobile via CSS) */
  const prevArrow = document.querySelector('.gallery-arrow--prev');
  const nextArrow = document.querySelector('.gallery-arrow--next');
  prevArrow?.addEventListener('click', () => goToSlide(currentIndex() - 1));
  nextArrow?.addEventListener('click', () => goToSlide(currentIndex() + 1));

  /* Dot clicks — mobile gallery navigation */
  dots.forEach(dot => {
    dot.addEventListener('click', () => goToSlide(parseInt(dot.dataset.index || 0)));
  });

  /* After 60s of idle (no user activity), play first video if product has one */
  const firstVideoIndex = thumbs.findIndex(t => t.dataset.mediaType === 'video');
  if (firstVideoIndex !== -1) {
    let idleTimer;
    const IDLE_MS = 60000;
    const resetIdle = () => {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(() => { if (window.innerWidth > 900) goToSlide(firstVideoIndex); }, IDLE_MS);
    };
    ['scroll', 'mousemove', 'click', 'touchstart', 'keydown'].forEach(ev =>
      document.addEventListener(ev, resetIdle, { passive: true })
    );
    resetIdle();
  }

  /* Mobile swipe — live finger tracking with slide animation */
  if (mainWrap) {
    mainWrap.style.overflow = 'hidden';
    let txStart = 0, tyStart = 0, swipeActive = false, swipeDir = 0, ghostEl = null;

    mainWrap.addEventListener('touchstart', e => {
      txStart = e.touches[0].clientX;
      tyStart = e.touches[0].clientY;
      swipeActive = false; swipeDir = 0; ghostEl = null;
    }, { passive: true });

    mainWrap.addEventListener('touchmove', e => {
      const dx = e.touches[0].clientX - txStart;
      const dy = e.touches[0].clientY - tyStart;
      if (!swipeActive && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
        swipeActive = true;
        swipeDir = dx < 0 ? 1 : -1;
        const adjIdx = ((currentIndex() + swipeDir + thumbs.length) % thumbs.length);
        const adjThumb = thumbs[adjIdx];
        if (adjThumb && adjThumb.dataset.mediaType !== 'video' && adjThumb.dataset.src) {
          ghostEl = document.createElement('img');
          ghostEl.src = adjThumb.dataset.src;
          ghostEl.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;will-change:transform;pointer-events:none;';
          ghostEl.style.transform = `translateX(${swipeDir * 100}%)`;
          const arrows = mainWrap.querySelector('.product-gallery__arrows');
          arrows ? mainWrap.insertBefore(ghostEl, arrows) : mainWrap.appendChild(ghostEl);
        }
      }
      if (!swipeActive) return;
      const pct = (dx / mainWrap.offsetWidth) * 100;
      const curEl = mainWrap.querySelector('#main-product-image, #main-product-video');
      if (curEl) { curEl.style.willChange = 'transform'; curEl.style.transform = `translateX(${pct}%)`; }
      if (ghostEl) ghostEl.style.transform = `translateX(${swipeDir * 100 + pct}%)`;
    }, { passive: true });

    mainWrap.addEventListener('touchend', e => {
      if (!swipeActive) return;
      const dx = e.changedTouches[0].clientX - txStart;
      const curEl = mainWrap.querySelector('#main-product-image, #main-product-video');
      const snap = thumbs.length > 1 && Math.abs(dx) >= mainWrap.offsetWidth * 0.25;
      const DURATION = 280;
      const ease = `transform ${DURATION}ms cubic-bezier(0.25,0.46,0.45,0.94)`;
      if (snap) {
        if (curEl) { curEl.style.transition = ease; curEl.style.transform = `translateX(${swipeDir * -100}%)`; }
        if (ghostEl) { ghostEl.style.transition = ease; ghostEl.style.transform = 'translateX(0%)'; }
        setTimeout(() => { if (curEl) curEl.style.transition = ''; ghostEl = null; goToSlide(currentIndex() + swipeDir); }, DURATION);
      } else {
        if (curEl) { curEl.style.transition = ease; curEl.style.transform = 'translateX(0%)'; }
        if (ghostEl) { ghostEl.style.transition = ease; ghostEl.style.transform = `translateX(${swipeDir * 100}%)`; }
        const captured = ghostEl;
        setTimeout(() => {
          if (curEl) { curEl.style.transition = ''; curEl.style.transform = ''; curEl.style.willChange = ''; }
          if (captured && captured.parentNode) captured.parentNode.removeChild(captured);
          ghostEl = null;
        }, DURATION);
      }
      swipeActive = false;
    }, { passive: true });
  }

  /* Mobile: tap main image to advance to next slide */
  if (mainWrap && thumbs.length >= 2) {
    mainWrap.addEventListener('click', function (e) {
      if (window.innerWidth > 900) return;
      if (e.target.closest('.gallery-arrow')) return;
      goToSlide(currentIndex() + 1);
    });
  }

  /* ── Product Accordion (one section open at a time) ── */
  document.querySelectorAll('.product-accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.product-accordion-item');
      const isOpen = item.classList.contains('open');

      item.closest('.product-description').querySelectorAll('.product-accordion-item.open').forEach(openItem => {
        openItem.classList.remove('open');
        openItem.querySelector('.product-accordion-trigger').setAttribute('aria-expanded', 'false');
        openItem.querySelector('.product-accordion-body').style.maxHeight = '0';
      });

      if (!isOpen) {
        const body = item.querySelector('.product-accordion-body');
        item.classList.add('open');
        trigger.setAttribute('aria-expanded', 'true');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });

  // Init open accordions
  document.querySelectorAll('.product-accordion-item.open .product-accordion-body').forEach(body => {
    body.style.maxHeight = body.scrollHeight + 'px';
  });


  /* ── Account Tabs (login page) ── */
  const tabLogin    = document.getElementById('tab-login');
  const tabRegister = document.getElementById('tab-register');
  const panelLogin  = document.getElementById('panel-login');
  const panelReg    = document.getElementById('panel-register');

  tabLogin?.addEventListener('click', () => {
    tabLogin.classList.add('active');
    tabRegister.classList.remove('active');
    panelLogin.style.display  = 'block';
    panelReg.style.display    = 'none';
  });
  tabRegister?.addEventListener('click', () => {
    tabRegister.classList.add('active');
    tabLogin.classList.remove('active');
    panelReg.style.display    = 'block';
    panelLogin.style.display  = 'none';
  });

  /* ── Account Page Tabs ── */
  document.querySelectorAll('[data-panel]').forEach(tab => {
    tab.addEventListener('click', () => {
      document.querySelectorAll('[data-panel]').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      const panelId = 'panel-' + tab.dataset.panel;
      ['orders', 'details', 'addresses'].forEach(name => {
        const el = document.getElementById('panel-' + name);
        if (el) el.style.display = name === tab.dataset.panel ? 'block' : 'none';
      });
    });
  });

  /* ── Announcement Bar (if added) ── */
  const annBar = document.getElementById('announcement-bar');
  if (annBar) {
    document.querySelector(':root').style.setProperty(
      '--header-height', (64 + annBar.offsetHeight) + 'px'
    );
  }

});

/* "Offer ends in" countdown (snippets/price-drop-timer): 10-minute window per visitor, kept in
   localStorage so a reload doesn't restart it; a fresh window starts when it runs out */
(function () {
  function start() {
    var els = document.querySelectorAll('[data-offer-window]');
    if (!els.length) return;
    var KEY = 'dreya-offer-start';
    var win = +els[0].dataset.offerWindow || 600;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function begin() {
      var now = Math.floor(Date.now() / 1000), t = 0;
      try { t = +localStorage.getItem(KEY) || 0; } catch (e) {}
      if (!t || now - t >= win || t > now) { t = now; try { localStorage.setItem(KEY, t); } catch (e) {} }
      return t;
    }
    var t0 = begin();
    function tick() {
      var left = win - (Math.floor(Date.now() / 1000) - t0);
      if (left <= 0) { t0 = begin(); left = win; }
      Array.prototype.forEach.call(els, function (el) {
        var mm = el.querySelector('[data-u="m"]'), ss = el.querySelector('[data-u="s"]');
        if (mm) mm.textContent = pad(Math.floor(left / 60)) + 'm';
        if (ss) ss.textContent = pad(left % 60) + 's';
        var both = el.querySelector('[data-u="mmss"]');
        if (both) both.textContent = pad(Math.floor(left / 60)) + ':' + pad(left % 60);
      });
    }
    tick();
    setInterval(tick, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
